/* ==========================================================================
   HEADER 1 DEDICATED JAVASCRIPT CONTROLLER (INDEPENDENT)
   ========================================================================== */

function initHeader1() {
    initHeader1MobileMenu();
    initHeader1Pickers();
    initHeader1CartSearch();
    initHeader1Sticky();
    initHeader1HoverIntent();
}

/* Alias for backward compatibility */
function initHeader() {
    initHeader1();
}

/* ==========================================================================
   1. MOBILE DRAWER SIDEBAR & ACCORDION SUBMENUS
   ========================================================================== */
function initHeader1MobileMenu() {
    const toggleBtn = document.getElementById("spi_mobile-toggle");
    const desktopToggleBtn = document.getElementById("spi_desktop-toggle");
    const closeBtn = document.getElementById("spi_mobile-close");
    const drawer = document.getElementById("spi_mobile-drawer");
    const overlay = document.getElementById("spi_mobile-overlay");

    if (!drawer) return;

    function openMobileMenu() {
        drawer.classList.add("spi_active");
        if (overlay) overlay.classList.add("spi_active");
        if (desktopToggleBtn) desktopToggleBtn.setAttribute("aria-expanded", "true");
        document.documentElement.style.overflow = "hidden";
    }

    function closeMobileMenu() {
        drawer.classList.remove("spi_active");
        if (overlay) overlay.classList.remove("spi_active");
        if (desktopToggleBtn) desktopToggleBtn.setAttribute("aria-expanded", "false");
        document.documentElement.style.overflow = "";
    }

    [toggleBtn, desktopToggleBtn].forEach(btn => {
        if (!btn) return;
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            openMobileMenu();
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
            e.preventDefault();
            closeMobileMenu();
        });
    }

    if (overlay) {
        overlay.addEventListener("click", function () {
            closeMobileMenu();
        });
    }

    // Accordion Submenu Toggles in Mobile Drawer
    const titleWraps = drawer.querySelectorAll(".spi_mobile-menu-title-wrap");
    titleWraps.forEach(wrap => {
        wrap.addEventListener("click", function (e) {
            const link = wrap.querySelector(".spi_mobile-menu-link");
            if (e.target === link && link.getAttribute("href") !== "#") {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            const parentItem = this.closest(".spi_mobile-menu-item");
            if (parentItem && parentItem.classList.contains("spi_has-dropdown")) {
                const isOpen = parentItem.classList.contains("spi_open");

                drawer.querySelectorAll(".spi_mobile-menu-item.spi_open").forEach(item => {
                    if (item !== parentItem) {
                        item.classList.remove("spi_open");
                    }
                });

                parentItem.classList.toggle("spi_open", !isOpen);
            }
        });
    });
}

/* ==========================================================================
   2. DESKTOP & MOBILE LANGUAGE / CURRENCY PICKERS
   ========================================================================== */
function initHeader1Pickers() {
    const pickers = document.querySelectorAll("[data-picker]");

    pickers.forEach(picker => {
        const btn = picker.querySelector("[data-picker-toggle]");
        const dropdown = picker.querySelector("[data-picker-dropdown]");
        if (!btn || !dropdown) return;

        btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = picker.classList.contains("spi_active");

            pickers.forEach(other => {
                if (other !== picker) {
                    other.classList.remove("spi_active");
                    const otherBtn = other.querySelector("[data-picker-toggle]");
                    if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
                }
            });

            picker.classList.toggle("spi_active", !isOpen);
            btn.setAttribute("aria-expanded", String(!isOpen));
        });
    });

    document.addEventListener("click", function (e) {
        pickers.forEach(picker => {
            if (!picker.contains(e.target)) {
                picker.classList.remove("spi_active");
                const btn = picker.querySelector("[data-picker-toggle]");
                if (btn) btn.setAttribute("aria-expanded", "false");
            }
        });
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            pickers.forEach(picker => {
                picker.classList.remove("spi_active");
                const btn = picker.querySelector("[data-picker-toggle]");
                if (btn) btn.setAttribute("aria-expanded", "false");
            });
        }
    });
}

/* ==========================================================================
   3. CART & SEARCH TRIGGERS
   ========================================================================== */
function initHeader1CartSearch() {
    /* Cart icon click + badge are owned by sections/cart-drawer.liquid, which
       is aware of the cart_type setting (drawer vs. page) and self-initializes. */

    const modal = document.getElementById("spi_search-modal");
    const overlay = document.getElementById("spi_search-overlay");
    const closeBtn = document.getElementById("spi_search-close");
    const input = document.getElementById("spi_search-input");
    const clearBtn = document.getElementById("spi_search-clear");
    const resultsEl = document.getElementById("spi_search-modal-results");
    const popularWrapper = document.getElementById("spi_search-popular-wrapper");
    const suggestedWrapper = document.getElementById("spi_search-suggested-wrapper");

    function openSearchModal() {
        if (!modal) return;
        modal.classList.add("spi_active");
        if (overlay) overlay.classList.add("spi_active");
        document.documentElement.style.overflow = "hidden";
        if (input) {
            window.setTimeout(function () {
                input.focus();
            }, 100);
        }
    }

    function closeSearchModal() {
        if (!modal) return;
        modal.classList.remove("spi_active");
        if (overlay) overlay.classList.remove("spi_active");
        document.documentElement.style.overflow = "";
    }

    window.openSearchModal = openSearchModal;
    window.closeSearchModal = closeSearchModal;

    const searchToggles = document.querySelectorAll("#spi_search-toggle, .spi_search-trigger");
    searchToggles.forEach(btn => {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            openSearchModal();
        });
    });

    if (closeBtn) closeBtn.addEventListener("click", closeSearchModal);
    if (overlay) overlay.addEventListener("click", closeSearchModal);
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && modal && modal.classList.contains("spi_active")) {
            closeSearchModal();
        }
    });

    if (input && resultsEl && input.dataset.predictiveSearchEnabled === "true") {
        let debounceTimer;
        let activeController;
        const loadingHtml = '<div class="spi_search-loading"><span class="spi_search-loading-spinner" aria-hidden="true"></span></div>';

        function runSearch(term) {
            if (activeController) activeController.abort();
            activeController = new AbortController();

            const url = input.dataset.predictiveSearchUrl || window.routes.predictive_search_url;
            const types = input.dataset.predictiveSearchTypes || "product";
            const limit = input.dataset.predictiveSearchLimit || "6";

            fetch(url + "?q=" + encodeURIComponent(term) +
                "&section_id=predictive-search" +
                "&resources[type]=" + encodeURIComponent(types) +
                "&resources[limit]=" + encodeURIComponent(limit) +
                "&resources[limit_scope]=each", {
                signal: activeController.signal
            })
                .then(function (res) {
                    return res.text();
                })
                .then(function (html) {
                    /* The Section Rendering API wraps the response in
                       <div id="shopify-section-predictive-search" class="shopify-section">,
                       and .shopify-section carries the global content-grid layout
                       (display: grid) from critical.css — strip that wrapper so it
                       doesn't hijack the results layout. */
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    const section = doc.getElementById("shopify-section-predictive-search");
                    resultsEl.innerHTML = section ? section.innerHTML : html;
                })
                .catch(function (err) {
                    if (err.name !== "AbortError") {
                        resultsEl.innerHTML = "";
                    }
                });
        }

        function setTerm(term) {
            input.value = term;
            if (clearBtn) clearBtn.classList.toggle("visible", term.length > 0);
            if (popularWrapper) popularWrapper.hidden = term.length > 0;
            if (suggestedWrapper) suggestedWrapper.hidden = term.length > 0;

            window.clearTimeout(debounceTimer);

            if (term.length < 1) {
                if (activeController) activeController.abort();
                resultsEl.innerHTML = "";
                return;
            }

            // Show the loader immediately on keystroke rather than waiting
            // out the debounce + fetch round trip, so results never sit
            // blank in the meantime.
            resultsEl.innerHTML = loadingHtml;

            debounceTimer = window.setTimeout(function () {
                runSearch(term);
            }, 250);
        }

        input.addEventListener("input", function () {
            setTerm(input.value.trim());
        });

        if (clearBtn) {
            clearBtn.addEventListener("click", function () {
                setTerm("");
                input.focus();
            });
        }

        document.querySelectorAll(".spi_search-tag").forEach(function (tag) {
            tag.addEventListener("click", function () {
                setTerm(tag.dataset.query || tag.textContent.trim());
            });
        });
    }
}

/* ==========================================================================
   4. STICKY HEADER
   ========================================================================== */
function initHeader1Sticky() {
    const header = document.querySelector(".spi_header");
    if (!header) return;

    const stickyType = header.dataset.sticky;
    const mainHeader = header.querySelector(".spi_main-header, .spi_header-v2-sticky");

    /* Only the three real sticky modes get the fixed-position CSS + scroll
       behavior. Anything else — "none", an empty value, or a stale value from
       an older schema like "no-sticky-header" — means the header stays in
       normal flow, so bail and clear any inline top a previous run may have
       left behind (theme-editor re-init). */
    const STICKY_TYPES = ["on-scroll-up", "always", "reduce-logo-size"];
    if (!mainHeader || STICKY_TYPES.indexOf(stickyType) === -1) {
        if (mainHeader) mainHeader.style.top = "";
        return;
    }

    /* The header is position: fixed with top: 0, which by itself ignores
       the announcement bar sitting above it in normal flow — at scroll
       position 0 both would try to occupy the same viewport space. Track
       the announcement bar's own height (it isn't fixed, so it scrolls
       away normally) and offset the header below it, sliding up to 0 as
       the announcement bar scrolls out of view. */
    /* .spi_top-header is the Default announcement bar layout; .spi_top-header-v2
       is the Scrolling marquee layout — only one exists at a time, depending on
       the merchant's chosen layout, so both are checked here. Re-queries the DOM
       each time rather than caching a single element reference, since a stale
       null reference (captured before the bar existed, or for the wrong layout)
       would permanently report 0 height and let the fixed header cover the bar. */
    function measureAnnouncementBar() {
        const bar = document.querySelector(".spi_top-header, .spi_top-header-v2");
        announcementHeight = bar ? bar.offsetHeight : 0;
    }

    /* The fixed header's height varies (a long menu wraps onto extra rows,
       a tall logo), so the in-flow spacer mirrors its real height instead of
       a hardcoded 90px. Skipped while shrunk so the page doesn't jump. */
    function syncHeaderHeight() {
        if (mainHeader.classList.contains("spi_header--shrink")) return;
        header.style.setProperty("--spi-header-height", mainHeader.offsetHeight + "px");
    }
    syncHeaderHeight();
    if ("ResizeObserver" in window) {
        new ResizeObserver(syncHeaderHeight).observe(mainHeader);
    }

    let announcementHeight = 0;
    measureAnnouncementBar();

    let lastScrollY = window.scrollY;
    const shrinkThreshold = 80;
    let ticking = false;

    function update() {
        const currentScrollY = window.scrollY;

        mainHeader.style.top = Math.max(0, announcementHeight - currentScrollY) + "px";

        mainHeader.classList.toggle("spi_header--scrolled", currentScrollY > 4);

        if (stickyType === "on-scroll-up") {
            const scrollingDown = currentScrollY > lastScrollY;
            const pastThreshold = currentScrollY > shrinkThreshold;
            mainHeader.classList.toggle("spi_header--hidden", scrollingDown && pastThreshold);
        }

        if (stickyType === "reduce-logo-size") {
            mainHeader.classList.toggle("spi_header--shrink", currentScrollY > shrinkThreshold);
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    update();

    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener("resize", function () {
        measureAnnouncementBar();
        update();
    });

    /* The bar's height depends on its text (a long announcement wraps onto
       several lines, and late-loading fonts can change that), not just the
       viewport width — re-measure whenever the bar itself resizes. */
    const announcementBar = document.querySelector(".spi_top-header, .spi_top-header-v2");
    if (announcementBar && "ResizeObserver" in window) {
        new ResizeObserver(function () {
            measureAnnouncementBar();
            update();
        }).observe(announcementBar);
    }
}

/* ==========================================================================
   DESKTOP DROPDOWN HOVER INTENT
   Panels hang from the header's bottom edge, so when the menu wraps onto
   several rows the cursor crosses lower-row items on its way down to an
   open panel. Switching to another item is delayed when it sits on a
   different row; if the cursor reaches the open panel first, it stays open.
   The list gets .spi_hover-intent and CSS opens panels on .spi_is-open
   instead of :hover.
   ========================================================================== */
function initHeader1HoverIntent() {
    const SWITCH_DELAY = 300;
    const CLOSE_DELAY = 200;

    document.querySelectorAll(".spi_menu-list, .spi_nav-v2-menu").forEach(list => {
        if (list.dataset.hoverIntent) return;
        list.dataset.hoverIntent = "true";
        list.classList.add("spi_hover-intent");

        const items = Array.from(list.children).filter(item =>
            item.matches(".spi_has-dropdown, .spi_has-dropdown-v2, .spi_has-megamenu")
        );
        let current = null;
        let timer = null;

        function open(item) {
            if (current && current !== item) current.classList.remove("spi_is-open");
            item.classList.add("spi_is-open");
            current = item;
        }

        function close() {
            if (current) current.classList.remove("spi_is-open");
            current = null;
        }

        items.forEach(item => {
            item.addEventListener("mouseenter", () => {
                clearTimeout(timer);
                if (!current || item === current) {
                    open(item);
                } else if (item.offsetTop === current.offsetTop) {
                    open(item);
                } else {
                    timer = setTimeout(() => open(item), SWITCH_DELAY);
                }
            });

            item.addEventListener("mouseleave", () => {
                clearTimeout(timer);
                timer = setTimeout(close, CLOSE_DELAY);
            });
        });

        // Items without a dropdown close the open panel straight away.
        Array.from(list.children).forEach(item => {
            if (items.includes(item)) return;
            item.addEventListener("mouseenter", () => {
                clearTimeout(timer);
                timer = setTimeout(close, current ? SWITCH_DELAY : 0);
            });
        });
    });
}

// Auto-run if DOM loaded or component loaded dynamically
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeader1);
} else {
    initHeader1();
}

window.initHeader1 = initHeader1;
window.initHeader = initHeader;
